import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95d70c40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-xl text-center my-2" }
const _hoisted_2 = ["disabled", "onClick"]

import { IonIcon, IonModal, IonContent } from '@ionic/vue'
import ResetModal from '@/components/modals/ResetModal.vue'
import { useGwModal } from '@/plugins/gw-modal'
import { useModal } from '@/composables/modal'
import GwBottomSheet from '@/plugins/gw-modal/GwBottomSheet.vue'
import GwModal from '@/plugins/gw-modal/GwModal.vue'
import { reactive, watch, onMounted, nextTick, ref, computed } from 'vue'
import { Form } from 'vee-validate'
import { IonSpinner } from '@ionic/vue'

import GwInput from '@/components/GwInput.vue'
import GwApiErrors from '@/plugins/gw-api-errors/GwApiErrors.vue'
import { useStore } from 'vuex'
import { State } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useEvents } from '@/composables/events'
import { useEventHandlers } from '@/composables/eventHandlers'
import FixedBottomControls from '@/components/modals/parts/FixedBottomControls.vue'
import { useFixedBottom } from '@/composables/fixedBottom'
import { useIonContent } from '@/composables/ionContent'
import { useGWAnalytics } from '@/plugins/analytics'
import { useGWAnalyticsBasePayload } from '../../plugins/analytics/composables/analyticsBasePayload'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginModal',
  setup(__props) {

const gwModal = useGwModal()
const { modalOpen, modalType, onModalDismiss, onModalWillDismiss } = useModal('login')

const { clickDelay } = useEventHandlers()
const store = useStore<State>()
const form = reactive({ email: '', password: '' })
watch(() => form.email, (newEmail, oldEmail) => {
  if (newEmail && newEmail !== oldEmail) {
    store.commit('updatedUser', {
      email: newEmail,
    })
  }
})

onMounted(async () => {
  if (store.state.user.email) {
    await nextTick()
    form.email = store.state.user.email
  }
})

const formRef = ref<any>(null)
const error = ref<any>(null)
const router = useRouter()
const { track, vAnalyticsClick } = useGWAnalytics()
const { payload } = useGWAnalyticsBasePayload()
const processing = ref(false)

const login = async (setTouched: (fields: boolean | Partial<Record<string, boolean>>) => void) => {
  processing.value = true
  try {
    await store.dispatch('login', {
      login: form.email,
      password: form.password,
    })

    track('login', { 
			...payload.value,
			user: store.state.user 
		})
    if (store.state.order.store === undefined) {
      router.push('/zoznam')
    }
    close()
  } catch (err: any) {
    setTouched({ email: false, password: false })
    error.value = err
  } finally {
    processing.value = false
  }
}

const { addClosedHook, modalEventBus, openModalEvent } = useEvents()
const showReset = () => {
	addClosedHook('login', async () => {
		addClosedHook('reset', () => openModalEvent('login'))
		openModalEvent('reset')
	})
	close()
}
const close = () => {
	modalEventBus.emit('close', { type: 'login' })
}

const route = useRoute()
const { t } = useI18n()

const emailInput = ref()
const passwordInput = ref()
const inputFocused = ref(false)
const fixedDismissButton = ref(true)
const { fixedPaddingBottom, onFixedBottomResize } = useFixedBottom()
const { scrollIonContentToElement } = useIonContent()
const isBraveOrFirefox = computed(() => !!(window as any).__firefox__ || /firefox|fxios/i.test(navigator.userAgent))

const onInputFocus = async (content: InstanceType<typeof IonContent>, input: any) => {
	if (isBraveOrFirefox.value) {
		inputFocused.value = true
		fixedDismissButton.value = false
		scrollIonContentToElement(content, (input.$el as HTMLElement))
	}
}

const onInvalidSubmit = async (content: InstanceType<typeof IonContent>, { errors }: { errors: any }) => {
	const invalidElement = document.querySelector(`input[name=${Object.keys(errors)[0]}]`)?.closest('ion-item')
	await nextTick()
	scrollIonContentToElement(content, invalidElement as HTMLElement)
	track('form_error', {
		...payload.value,
    form_name: `Login - ${Object.keys(errors).join(', ')}`,
		value: Object.keys(errors).join(', ')
  })
}

const onInputBlur = () => {
	inputFocused.value = false
	fixedDismissButton.value = true
}
const focusInput = (input: any) => {
	if (input.$el) (input.$el as HTMLElement).querySelector('input')?.focus()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonModal), {
      id: "LoginModal",
      animated: true,
      class: _normalizeClass(_unref(modalType) === 'bottomSheet' ? 'gw-modal-sheet' : ''),
      "enter-animation": _unref(modalType) === 'overlay' ? _unref(gwModal).enterAnimationDefinition : undefined,
      "leave-animation": _unref(modalType) === 'overlay' ? _unref(gwModal).leaveAnimationDefinition : undefined,
      "is-open": _unref(modalOpen),
      breakpoints: _unref(modalType) === 'bottomSheet' ? [0,1] : undefined,
      "initial-breakpoint": _unref(modalType) === 'bottomSheet' ? 1 : undefined,
      "can-dismiss": true,
      onWillDismiss: _unref(onModalWillDismiss),
      onDidDismiss: _unref(onModalDismiss)
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(modalType) === 'bottomSheet' ? GwBottomSheet : GwModal), {
          "fixed-dismiss-button": fixedDismissButton.value,
          name: "LoginModal"
        }, {
          default: _withCtx(({ content }) => [
            _createVNode(_unref(Form), {
              ref_key: "formRef",
              ref: formRef,
              as: "",
              onInvalidSubmit: ($event) => onInvalidSubmit(content, $event)
            }, {
              default: _withCtx(({ handleSubmit, submitCount, meta, setTouched }) => [
                _createElementVNode("div", {
                  class: "w-full",
                  style: _normalizeStyle(inputFocused.value ? undefined : { 'padding-bottom': _unref(fixedPaddingBottom) })
                }, [
                  _createVNode(_unref(IonIcon), {
                    src: require('@/assets/user-circle.svg'),
                    class: "gw-main-icon text-[3.125rem] rounded-md mx-auto text-primary"
                  }, null, 8, ["src"]),
                  _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("welcome_back")), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full", submitCount ? '' : 'not-submitted'])
                  }, [
                    _createVNode(GwInput, {
                      ref_key: "emailInput",
                      ref: emailInput,
                      modelValue: form.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
                      class: "my-2.5",
                      autocomplete: isBraveOrFirefox.value ? undefined : 'username',
                      name: "email",
                      type: "email",
                      label: _unref(t)('login.form.labels.email'),
                      rules: "required|email",
                      onFocus: () => onInputFocus(content, emailInput.value),
                      onBlur: onInputBlur,
                      onKeyupEnter: _cache[1] || (_cache[1] = ($event: any) => (focusInput(passwordInput.value)))
                    }, null, 8, ["modelValue", "autocomplete", "label", "onFocus"]),
                    _createVNode(GwInput, {
                      ref_key: "passwordInput",
                      ref: passwordInput,
                      modelValue: form.password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.password) = $event)),
                      class: "my-0.5",
                      name: "password",
                      type: "password",
                      "update-on-input": true,
                      label: _unref(t)('login.form.labels.password'),
                      rules: "required|min:8",
                      onFocus: () => onInputFocus(content, passwordInput.value),
                      onBlur: onInputBlur,
                      onKeyupEnter: ($event: any) => (handleSubmit(() => login(setTouched)))
                    }, null, 8, ["modelValue", "label", "onFocus", "onKeyupEnter"]),
                    _createVNode(GwApiErrors, {
                      meta: meta,
                      error: error.value
                    }, null, 8, ["meta", "error"]),
                    _withDirectives((_openBlock(), _createElementBlock("a", {
                      class: "inline-block text-13 leading-tight text-grey mt-1.5 mb-6 pl-2.5 hover:text-primary",
                      href: "#",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showReset()), ["prevent"]))
                    }, [
                      _createTextVNode(_toDisplayString(_unref(t)("forget_password_question")), 1)
                    ])), [
                      [_unref(vAnalyticsClick), _unref(route)]
                    ]),
                    _createVNode(FixedBottomControls, {
                      class: _normalizeClass({ '!relative !px-0': inputFocused.value }),
                      onResize: _unref(onFixedBottomResize)
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                          class: "gw-button -primary relative",
                          disabled: processing.value,
                          onClick: _withModifiers(($event: any) => (_unref(clickDelay)(() => handleSubmit(() => login(setTouched)))), ["prevent"])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(processing.value ? 'opacity-0' : '')
                          }, _toDisplayString(_unref(t)("log_in")), 3),
                          (processing.value)
                            ? (_openBlock(), _createBlock(_unref(IonSpinner), {
                                key: 0,
                                class: "absolute text-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                                name: "crescent"
                              }))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_2)), [
                          [_unref(vAnalyticsClick), _unref(route)]
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                          class: "gw-button -secondary",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(clickDelay)(close)), ["prevent"]))
                        }, [
                          _createTextVNode(_toDisplayString(_unref(t)("back_to_order")), 1)
                        ])), [
                          [_unref(vAnalyticsClick), _unref(route)]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class", "onResize"])
                  ], 2)
                ], 4)
              ]),
              _: 2
            }, 1032, ["onInvalidSubmit"])
          ]),
          _: 1
        }, 8, ["fixed-dismiss-button"]))
      ]),
      _: 1
    }, 8, ["class", "enter-animation", "leave-animation", "is-open", "breakpoints", "initial-breakpoint", "onWillDismiss", "onDidDismiss"]),
    _createVNode(ResetModal)
  ], 64))
}
}

})